exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dlnkmessages_recipient[data-v-7e645f94] {\n  display: inline-block;\n  border: 1px solid #0049a4;\n  border-radius: 10px;\n  margin-top: 2px;\n  padding-left: 8px;\n  padding-right: 8px;\n  margin-right: .33em;\n}\n\n", ""]);

// exports
